import React, { useEffect, useState } from 'react';

import { store } from 'redux/store';
import { setCurrentTab, setSearchQuery } from 'redux/reducers/mailerLayoutReducer';
import NewTemplate from 'components/Admin/Mailer/Templates/NewTemplate';
import TemplateList from 'components/Admin/Mailer/Templates/TemplateList';
import TemplateListMobile from 'components/Admin/Mailer/Templates/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function MailerTemplates() {
  const [showNewTemplateForm, setShowNewTemplateForm] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('templates'));
    store.dispatch(setSearchQuery(''));
  }, []);

  if (showNewTemplateForm) {
    return (
      <div className="bg-gray">
        <NewTemplate close={() => setShowNewTemplateForm(false)} />
      </div>
    );
  }

  return (
    <div className="bg-gray">
      {isMobile
        ? <TemplateListMobile openNewTemplateForm={() => setShowNewTemplateForm(true)} />
        : <TemplateList openNewTemplateForm={() => setShowNewTemplateForm(true)} />}
    </div>
  );
}
